export const FEATURE_AI_SEARCH = "MT AI Search";

export const BYO_WORDS_QUERY_PARAM_NAME = 'words';
export const BYO_WORDS_COUNT_QUERY_PARAM_NAME = 'wordsCount';
export const BYO_SETTINGS_ID_QUERY_PARAM_NAME = 'byoSettingId';
export const BYO_INSTANT_CHART_ID_QUERY_PARAM_NAME = 'instantChartId';
